import { withRouter, useLocation } from 'react-router'
import { useState, useContext } from 'react';
import appTheme from "../appTheme"
import LinkButton from './linkbutton';
import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { AmplifySignOut } from '@aws-amplify/ui-react';
import { Auth, Hub } from 'aws-amplify';
import {Typography} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import EventContext from "../store/event-context";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';

const EventDetails = ({username, isAdmin}) => {
  //console.log("Call EventDetails with username: ", username, " and isAdmin: ", isAdmin);
    const [anchorHome, setAnchorHome] = useState(null);
    const openHome = Boolean(anchorHome);
    const handleClickHome = (event) => {
      setAnchorHome(event.currentTarget);
    };
    const handleCloseHome = () => {
      setAnchorHome(null);
    };

    const [anchorAdmin, setAnchorAdmin] = useState(null);
    const openAdmin = Boolean(anchorAdmin);
    const handleClickAdmin = (event) => {
      setAnchorAdmin(event.currentTarget);
    };
    const handleCloseAdmin = () => {
      setAnchorAdmin(null);
    };

    const large_window = useMediaQuery('(min-width:700px)');
    const orientationPortrait = (window.innerWidth < window.innerHeight);
    //console.log("Portrait? ", orientationPortrait, " h x w: ", window.screen.availHeight, window.screen.availWidth);
    //console.log("Portrait? ", orientationPortrait, " h x w: ", window.innerHeight, window.innerWidth);
    const eventctx = useContext(EventContext);
    const hasEvent = eventctx.eventId !== "";
    const currentLocation = useLocation();
    //console.log("Current location: ", currentLocation.pathname);

    const handleSignOutButtonClick = async () => {
      try {
        console.log("Clearing selected event and logging off")
        eventctx.clearEvent()
          await Auth.signOut();
          Hub.dispatch('UI Auth', {   // channel must be 'UI Auth'
              event: 'AuthStateChange',    // event must be 'AuthStateChange'
              message: 'signedout'    // message must be 'signedout'
          });
      } catch (error) {
          console.log('error signing out: ', error);
      }
    };

    const CustomSignOutButton = () => {
      return (
          <Button
              sx={{
                py: 0,
                fontFamily: 'Calibri, Arial, Helvetica, sans-serif',
                fontSize: '14px',
                color: 'common.white',
                bgcolor: 'inherit',
                fontWeight: '600',
                letterSpacing: '0.005em',
                textTransform: 'uppercase',
                paddingRight: '16px',
              }}
              onClick={handleSignOutButtonClick}>
              Log uit
          </Button>
      );
  };

    let title = "Partrack"
    if (hasEvent && !orientationPortrait) {
      title = eventctx.event.name;
    } else if (orientationPortrait && currentLocation.pathname === "/actorsIn") {
      title = "Te water";
    } else if (orientationPortrait && currentLocation.pathname === "/actorsOut") {
      title = "Uit het water"
    } else if (orientationPortrait && currentLocation.pathname === "/active") {
      title = "Zwemt nog"
    }

    return (
        <div id="totalHeader">
            <Grid container id="header" direction="row" justifyContent="space-between" alignItems="center" sx={{ bgcolor: 'primary.main', paddingLeft: 1 }}>
              { (!orientationPortrait) && <Grid item xs={3} sx={{ pt: "4px"}} >
                <LinkButton home id="HomeButton" to="/" >Home</LinkButton> 
              </Grid>}
              { orientationPortrait && <Grid item xs={3}>
                <IconButton sx={{ color: 'common.white'}} onClick={handleClickHome} aria-label="Menu">
                  <MenuIcon />
                </IconButton>
              </Grid>}
              {(!orientationPortrait) && <Grid item xs={6}>
                <Typography className="Title" variant="h5" align="center" gutterBottom sx={{ color: 'white' }}> {eventctx.event && eventctx.event.name }</Typography>
              </Grid>}
              {orientationPortrait && <Grid item xs={6}>
                <Typography className="Title" variant="h5" align="center" gutterBottom sx={{ color: 'white' }}> { title }</Typography>
              </Grid>}
              {orientationPortrait && <Grid item xs={3} >
                <Box display="flex" justifyContent="flex-end">
                  {/*(currentLocation.pathname === "/") ? <AmplifySignOut id="Logout" buttonText="Log uit" ></AmplifySignOut> : " " */}
                  {(currentLocation.pathname === "/") ? <IconButton sx={{ color: 'common.white', paddingRight: '10px'}}  onClick={handleSignOutButtonClick}><LogoutIcon /></IconButton> : " " }
                </Box>
              </Grid>}
              {(!orientationPortrait) && <Grid item xs={3}>
                <Box display="flex" justifyContent="flex-end">
                  {/*(currentLocation.pathname === "/") ? <AmplifySignOut id="Logout" buttonText="Log uit" ></AmplifySignOut> : " " */}
                  {(currentLocation.pathname === "/") ? <CustomSignOutButton /> : " " }
                </Box>
              </Grid>}
              <Menu
                anchorEl={anchorHome}
                id="hamburger-menu"
                open={openHome}
                onClose={handleCloseHome}
                onClick={handleCloseHome}>
                <MenuItem>
                    <LinkButton id="HomeButton" to="/">Home</LinkButton>
                </MenuItem>
                <Divider />
                <MenuItem>
                    <LinkButton id="actorIn" to="/actorsIn" >Te water</LinkButton>
                </MenuItem>
                <MenuItem>
                    <LinkButton id="actorOut" to="/actorsOut" >Uit het water</LinkButton>
                </MenuItem>
                <MenuItem>
                    <LinkButton id="active" to="/active" >Zwemt nog</LinkButton> 
                </MenuItem>
                {/* {(username === 'peter' || username === 'marga') && <MenuItem>
                    <LinkButton admin id="testDimensions" to="/testDimensions" disabled={!hasEvent}>Test sizes</LinkButton>
                </MenuItem>} */}
              </Menu>
            </Grid>
            { (!orientationPortrait) && <Grid container id="menubalk" spacing={0} justifyContent="flex-start" sx={{bgcolor: 'primary.light', py: 1, paddingLeft: 4}} >
                <Grid item xs={2}>
                    <LinkButton id="actorIn" to="/actorsIn" >Te water</LinkButton> 
                </Grid>
                <Grid item xs={2}>
                    <LinkButton id="actorOut" to="/actorsOut" >Uit het water</LinkButton> 
                </Grid>
                <Grid item xs={2}>
                    <LinkButton id="active" to="/active" disabled={!hasEvent}>Zwemt nog</LinkButton> 
                </Grid>
                <Grid item xs={2}>
                    <LinkButton id="participants" to="/participants" disabled={!hasEvent}>Aanmelden</LinkButton>
                </Grid>
                {isAdmin && <Grid item xs={2}>
                  <Button
                    sx={{ 
                      py: 0, 
                      color: 'error.dark',
                      fontFamily: 'Calibri, Arial, Helvetica, sans-serif',
                      fontSize: '1.05rem',
                      fontWeight: 'regular',
                      letterSpacing: '0.005em',
                      textTransform: 'none',
                    }}
                    onClick={handleClickAdmin}>
                    Admin
                  </Button>      
                  <Menu
                    anchorEl={anchorAdmin}
                    id="adminMenu"
                    open={openAdmin}
                    onClose={handleCloseAdmin}
                    onClick={handleCloseAdmin}>
                    <MenuItem>
                        <LinkButton admin id="overview" to="/overview" disabled={!hasEvent}>Deelnemers</LinkButton>
                    </MenuItem>
                    <MenuItem>
                        <LinkButton admin id="volunteers" to="/volunteers" disabled={!hasEvent}>Medewerkers</LinkButton>
                    </MenuItem>
                    <MenuItem>
                        <LinkButton admin id="unassigned" to="/unassigned" disabled={!hasEvent}>Vrije caps</LinkButton>
                    </MenuItem>
                    {/* {(username === 'peter') && <MenuItem>
                        <LinkButton admin id="participantAdd" to="/participantAdd" disabled={!hasEvent}>Nieuwe deelnemer</LinkButton>
                    </MenuItem>}
                    {(username === 'peter') && <MenuItem>
                        <LinkButton admin id="eventUpdate" to="/eventUpdate" disabled={!hasEvent}>Event gegevens</LinkButton>
                    </MenuItem>}
                    {(username === 'peter' || username === 'marga') && <MenuItem>
                        <LinkButton admin id="testDimensions" to="/testDimensions" disabled={!hasEvent}>Test screen sizes</LinkButton>
                    </MenuItem>} */}
                  </Menu>
                </Grid>}
            </Grid>}
            {/*(! large_window) && <Typography className="smallTitle" variant="h6" align="center" gutterBottom> {foundEvent && foundEvent.name }</Typography>*/}
        </div>
    )
}

export default withRouter(EventDetails)
